import React, {Component} from "react";
import {Header} from "semantic-ui-react";
import {Header as Head} from "../../components";
import ImgBanner from "../../assets/image/banner-home.jpg";

class About extends Component {

    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <React.Fragment>
                <Head ImgBanner={ImgBanner}>
                    <Header as="h1" textAlign="center">
                        About Belo Horizonte
                    </Header>
                </Head>
            </React.Fragment>
        );
    }
}

export default About;

